import { Link } from 'react-router-dom';

const footerLinks = {
  service: {
    title: '服务项目',
    links: [
      { name: '护士主题写真', path: '/category?tab=nurse-photoshoot' },
      { name: '角色扮演服装', path: '/category?tab=cosplay-costume' },
      { name: '美体护理', path: '/category?tab=body-care' },
      { name: '定制服务', path: '/category' },
    ],
  },
  brand: {
    title: '品牌信息',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '品牌故事', path: '/about' },
      { name: '客户口碑', path: '/about' },
      { name: '联系我们', path: '/about' },
    ],
  },
  articles: {
    title: '精选文章',
    links: [
      { name: '写真拍摄攻略', path: '/article/1' },
      { name: 'cosplay穿搭指南', path: '/article/2' },
      { name: '科学护肤哲学', path: '/article/3' },
      { name: '全部文章', path: '/articles' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="cursor-pointer">
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50">
                比基尼护士
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              融合医护专业与时尚美学的创意品牌。我们以严谨的态度和独特的审美，为每一位顾客打造难忘的视觉与体验。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 比基尼护士 BikiniNurse. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}